require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-boiler-house-rea-feature-article.json") })
        }
      }, "path---news-boiler-house-rea-feature-article");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-boiler-house-rea-feature-article!./.cache/json/news-boiler-house-rea-feature-article.json
// module id = 797
// module chunks = 231608221292675